// extracted by mini-css-extract-plugin
export var highlightFade = "_27-4";
export var highlighted = "_27-3";
export var table = "_27-1";
export var tableContainer = "_27-0";
export var totalsRow = "_27-2";